import { render, staticRenderFns } from "./index.vue?vue&type=template&id=800af2f2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=800af2f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800af2f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('800af2f2')) {
      api.createRecord('800af2f2', component.options)
    } else {
      api.reload('800af2f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=800af2f2&scoped=true", function () {
      api.rerender('800af2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/publicComponents/chooseVideo/index.vue"
export default component.exports